import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LoggingModule } from "../logging/logging.module";
import { MaterialModule } from "../material/material.module";
import { BadgletComponent } from "./badglet/badglet.component";
import { ClickToEditComponent } from "./click-to-edit/click-to-edit.component";
import { DateRangePickerComponent } from "./date-range-picker/date-range-picker.component";
import { LoadingOverlayComponent } from "./loading-overlay/loading-overlay.component";
import { MetricComponent } from "./metric/metric.component";
import { NavTogglerComponent } from "./nav-toggler/nav-toggler.component";
import { PendingValueComponent } from "./pending-value/pending-value.component";
import { RemovePageRangeDirective } from "./remove-page-range/remove-page-range.directive";
import { RenderingOptionsComponent } from "./rendering-options/rendering-options.component";
import { SentenceTableComponent } from "./sentence-table/sentence-table.component";
import { TokenFrequencyTableComponent } from "./token-frequency-table/token-frequency-table.component";
import { InlineTableEditComponent } from "./table-addons/inline-table-edit/inline-table-edit.component";
import { TableActionsComponent } from "./table-addons/table-actions/table-actions.component";
import { ThemeSelectorComponent } from "./theme-selector/theme-selector.component";
import { TruncatedLabelComponent } from "./truncated-label/truncated-label.component";
import { ReplacePipe } from "../category-builder/replace-with.pipe";
import { HeroIconModule } from "../icons/heroIcon.module";
import { TableAddonsModule } from "./table-addons/table-addons.module";
import { SharedTableComponent } from "./components/shared-table/shared-table.component";
import { SharedCardComponent } from "./components/shared-card/shared-card.component";
import { SharedDialogComponent } from "./components/shared-dialog/shared-dialog.component";
import { SharedActionButtonComponent } from "./components/shared-actions/shared-action-button.component";
import { SharedFormFieldComponent } from "./components/shared-form/shared-form-field.component";
import { SharedPillComponent } from "./components/shared-status/shared-pill.component";

const SHARED_LIBRARY_COMPONENTS = [
  SharedTableComponent,
  SharedCardComponent,
  SharedDialogComponent,
  SharedActionButtonComponent,
  SharedFormFieldComponent,
  SharedPillComponent,
];

@NgModule({
  declarations: [
    NavTogglerComponent,
    MetricComponent,
    ClickToEditComponent,
    PendingValueComponent,
    BadgletComponent,
    RemovePageRangeDirective,
    LoadingOverlayComponent,
    ThemeSelectorComponent,
    DateRangePickerComponent,
    TableActionsComponent,
    InlineTableEditComponent,
    SentenceTableComponent,
    TokenFrequencyTableComponent,
    RenderingOptionsComponent,
    TruncatedLabelComponent,
    ReplacePipe,
    ...SHARED_LIBRARY_COMPONENTS,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    LoggingModule,
    HeroIconModule,
    TableAddonsModule,
    TableAddonsModule,
    MaterialModule,
  ],
  exports: [
    NavTogglerComponent,
    MetricComponent,
    ClickToEditComponent,
    PendingValueComponent,
    BadgletComponent,
    RemovePageRangeDirective,
    LoadingOverlayComponent,
    ThemeSelectorComponent,
    DateRangePickerComponent,
    TableActionsComponent,
    InlineTableEditComponent,
    SentenceTableComponent,
    TokenFrequencyTableComponent,
    RenderingOptionsComponent,
    TruncatedLabelComponent,
    ReplacePipe,
    ...SHARED_LIBRARY_COMPONENTS,
  ],
})
export class SharedModule {}
